export default __webpack_public_path__ + "static/polygon4-9e6c3e01de9fad9eb07b085e2f50130a.png";